import { useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

/** Vuestic-compatible breakpoints from global-config.ts */
const VUESTIC_BREAKPOINTS = {
  xs: 0,
  sm: 320,
  md: 640,
  lg: 1024,
  xl: 1440,
} as const

export function useAppDisplay() {
  const breakpoints = useBreakpoints(VUESTIC_BREAKPOINTS)

  const xs = breakpoints.smaller('sm')
  const sm = breakpoints.between('sm', 'md')
  const md = breakpoints.between('md', 'lg')
  const lg = breakpoints.between('lg', 'xl')
  const xl = breakpoints.greaterOrEqual('xl')

  const xsDown = breakpoints.smaller('sm')
  const smDown = breakpoints.smaller('md')
  const mdDown = breakpoints.smaller('lg')
  const lgDown = breakpoints.smaller('xl')
  const xlDown = computed(() => false)

  const xsUp = breakpoints.greaterOrEqual('xs')
  const smUp = breakpoints.greaterOrEqual('sm')
  const mdUp = breakpoints.greaterOrEqual('md')
  const lgUp = breakpoints.greaterOrEqual('lg')
  const xlUp = breakpoints.greaterOrEqual('xl')

  return {
    xs,
    sm,
    md,
    lg,
    xl,
    xsDown,
    smDown,
    mdDown,
    lgDown,
    xlDown,
    xsUp,
    smUp,
    mdUp,
    lgUp,
    xlUp,
  }
}

/** @deprecated Use useAppDisplay — kept for migration compatibility */
export const useBreakpoint = useAppDisplay
